import { createSelector } from 'reselect';
import { featuredHeadToHeadSelector } from './simple-selectors';

export const featuredHeadToHeadDataSelector = createSelector(
    featuredHeadToHeadSelector,
    (featuredHeadToHead) => featuredHeadToHead.data
);
